<template>
  <div>
    <div>
      <vs-row v-if="!course_id">
        <vs-col vs-lg="12" vs-sm="12" class="p-2">
          <vs-input
            label="Search"
            v-model="search"
            @keyup="searchFun"
            placeholder="Enter the search"
            class="w-full"
          />
        </vs-col>
        <!-- <vs-col vs-lg="6" vs-sm="12" class="p-2">
          <label class="vs-input--label">Course Name</label>
          <v-select
            @input="fetchCourseList"
            placeholder="Select course"
            class="w-full"
            label="name"
            :options="courseListsForfilter"
            v-model="course_name"
            @open="onOpenCourse"
            @close="onCloseCourse"
            @search="fetchCourseListForFilter"
          >
            <template #list-footer>
              <li ref="loadCourse" class="loader" v-show="coursemeta.has_next">
                Loading more course...
              </li>
            </template></v-select
          >
        </vs-col> -->
        <vs-col vs-lg="4" vs-sm="12" class="p-2">
          <label class="vs-input--label">Course Pricing</label>
          <v-select
            @input="fetchCourseList"
            placeholder="Select pricing"
            class="w-full"
            label="name"
            :reduce="(option) => option.id"
            :options="coursePricings"
            v-model="course_payment_type"
          >
          </v-select>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="p-2">
          <label class="vs-input--label">Course Type</label>
          <v-select
            @input="fetchCourseList"
            label="value"
            :options="course_types"
            v-model="course_type"
            placeholder="Select course type"
            class="w-full"
            :clearable="true"
          >
          </v-select>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="p-2">
          <label class="vs-input--label">Delivery Location</label>
          <v-select
            @input="fetchCourseList"
            :reduce="(options) => options.id"
            label="name"
            :options="locations"
            v-model="delivery_location_id"
            placeholder="Select location"
            class="w-full"
          ></v-select>
        </vs-col>
        <vs-col vs-lg="12" vs-sm="12" class="p-2">
          <label class="vs-input--label">Course Teachers</label>
          <v-select
            @input="fetchCourseList"
            multiple
            v-model="teacher_id"
            :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
            class="w-full"
            placeholder="Select Teacher"
            :clearable="false"
            @open="onOpenTeacher"
            @close="onCloseTeacher"
            :options="teacherList"
            @search="fuseSearch"
          >
            <template v-slot:selected-option="teacherList">
              <img
                v-if="teacherList.picture"
                class="person-img rounded-full"
                :src="teacherList.picture"
              />
              <img
                v-else
                class="person-img rounded-full"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
              {{ teacherList.first_name }}
              {{ teacherList.last_name }}
            </template>
            <template v-slot:option="teacherList">
              <img
                v-if="teacherList.picture"
                class="person-img rounded-full"
                :src="teacherList.picture"
              />
              <img
                v-else
                class="person-img rounded-full"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
              {{ teacherList.first_name }}
              {{ teacherList.last_name }}
            </template>
            <template #list-footer>
              <li
                ref="loadTeacher"
                class="loader"
                v-show="teacher_meta.has_next"
              >
                Loading more teacher...
              </li>
            </template>
          </v-select>
        </vs-col>
      </vs-row>
    </div>
    <div>
      <div class="flex flex-wrap justify-between items-center p-2 mt-4">
        <h4>{{course_id?'Selected':'Select'}} Course</h4>
        <div class="flex items-center icon_holder ml-2">
          <vs-tooltip color="primary" position="top" text="Grid View">
            <span
              class="material-icons-outlined"
              :class="[grid ? 'active' : '']"
              @click="viewTab('grid')"
              >grid_view</span
            >
          </vs-tooltip>
          <vs-tooltip color="primary" position="top" text="List View">
            <span
              class="material-icons-outlined"
              :class="[list ? 'active' : '']"
              @click="viewTab('list')"
              >format_list_bulleted</span
            >
          </vs-tooltip>
        </div>
      </div>
      <div
        :class="[
          `cstm_view_holder ${
            list ? 'list_view_holder p-2' : 'grid_view_holder'
          }`,
        ]"
      >
        <div
          class="each_card"
          v-for="(eachData, index) in courseLists"
          :key="index"
          @click="addCourseId(eachData)"
          :class="[selected_course_id == eachData.id ? 'active' : '']"
        >
          <div class="relative img_status cursor-pointer">
            <!-- {{eachData}}                    -->
            <img
              v-if="Object.keys(eachData.courseImage).length > 0"
              :src="eachData.courseImage.file_path"
            />
            <img
              v-else
              src="https://scoolio-files.s3.ap-south-1.amazonaws.com/Scoolio/Students+watching+webinar+on+computer.jpg"
              alt="course_image"
            />
            <div class="course_status">
              <span class="material-icons-outlined">location_city</span>
              {{
                eachData.delivery_location_id != null
                  ? getDeliverylocation(eachData.delivery_location_id)
                  : ""
              }}
            </div>
          </div>
          <div class="content">
            <div class="flex justify-between">
              <h5 class="two_lines_truncate font-bold mb-2 cursor-pointer">
                {{ eachData.name }}
              </h5>
              <div class="course_status">
                <span class="material-icons-outlined">location_city</span>
                {{
                  eachData.delivery_location_id != null
                    ? getDeliverylocation(eachData.delivery_location_id)
                    : ""
                }}
              </div>
            </div>
            <p>
              Subject:
              {{
                eachData.has_all_subject
                  ? "General"
                  : getDSubjects(eachData.subjects)
              }}
            </p>
            <p>
              Class Type: {{ getCourseTypeName(eachData.course_class_type) }}
            </p>
            <div class="inline-flex flex-wrap justify-between mt-4 w-full">
              <p class="money_holder">£{{ eachData.total_price }}</p>
              <div class="flex items-center">
                <div
                  class="cstm-img-holder"
                  v-for="(tutor, index) in eachData.tutors"
                  :key="index"
                >
                  <vs-tooltip
                    :text="`${tutor.first_name} ${tutor.last_name}`"
                    position="top"
                    color="primary"
                  >
                    <img
                      v-if="tutor.picture != ''"
                      data-v-b18e1656=""
                      :src="tutor.picture"
                      alt="user-img"
                      width="20"
                      height="20"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                    <img
                      v-else
                      data-v-b18e1656=""
                      src="@/assets/images/pages/user-circle-solid.svg"
                      alt="user-img"
                      width="20"
                      height="20"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                  </vs-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full">
          <pagination :meta="meta" @page-change="handlePageChange" />
        </div>
      </div>
      <div v-if="courseLists.length == 0" class="text-center">
        No Course found
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Pagination from '@/components/common/pagination'

import { CourseBuilder } from '@/views/pages/v1/coursebuilder/mixin/courseBuilderMixin.js'

import { newcourseListing } from '@/api/course-builderapi'

export default {
  mixins: [CourseBuilder],
  props: {
    clear:false,
    course_id:null
  },
  watch: {
    clear () {
      if (this.clear) {
        this.selected_course_id = null
      }
    }
  },
  data () {
    return {
      selected_course_id: null,
      coursePricings: [
        {
          id: 1,
          name: 'Free'
        },
        {
          id: 2,
          name: 'Buy Now'
        },
        {
          id: 3,
          name: 'Per Session'
        },
        {
          id: 4,
          name: 'Recurring Payment'
        },
        {
          id: 5,
          name: 'Subscription'
        }
      ],
      course_class_type_list: [
        {
          value: 'self_based',
          name: 'Self Paced Course'
        },
        {
          value: 'online_one_2_one',
          name: 'Online Individual Course'
        },
        {
          value: 'online_one_2_many',
          name: 'Online Group Course'
        },
        {
          value: 'offline_one_2_one',
          name: 'In Person Individual Course'
        },
        {
          value: 'offline_one_2_many',
          name: 'In Person Group Course'
        }
      ],
      course_types: [
        { id: 1, type: 'self_based', value: 'Self Paced Course' },
        { id: 2, type: 'online_one_2_one', value: 'Online Individual Course' },
        { id: 3, type: 'online_one_2_many', value: 'Online Group Course' },
        {
          id: 4,
          type: 'offline_one_2_one',
          value: 'In Person Individual Course'
        },
        { id: 5, type: 'offline_one_2_many', value: 'In Person Group Course' }
      ],
      search: '',
      course_payment_type: null,
      teacher_id: null,
      course_type: null,
      course_name: null,
      delivery_location_id: null,
      grid: true,
      list: false,
      courseLists: [],
      courseListsForfilter: [],
      defaultImage: null,
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      coursemeta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },

      locations: [
        {
          id: 1,
          name: 'At School'
        },
        {
          id: 2,
          name: 'Online'
        },
        {
          id: 3,
          name: 'At Home'
        },
        {
          id: 4,
          name: 'Other'
        }
      ],
      customer_id: localStorage.getItem('customer_id'),
      observerCourse: new IntersectionObserver(this.loadMoreCourse)
    }
  },
  components: {
    vSelect,
    Pagination
  },
  mounted () {
    if(this.course_id) {
      this.fetchCourseList()
      this.selected_course_id = this.course_id
    }
    this.getTeacherList()
    this.fetchCourseList()
    this.fetchCourseListForFilter()
  },
  methods: {
    async addCourseId (courseDetails) {
      this.selected_course_id = courseDetails.id
      this.$emit('selectedCourse', this.selected_course_id, courseDetails)
    },
    async handlePageChange (page) {
      this.meta.current_page = page || 1
      this.fetchCourseList()
    },
    async loadMoreCourse ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          const { data } = await newcourseListing(
            //this.course_type,
            this.customer_id,
            {status : 1},
            this.coursemeta.current_page + 1,
            {},
            'course_table'
          )
          this.courseListsForfilter.push(...data.data.course)
          this.coursemeta = data.data.meta
        } catch (e) {
          //
        }
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async onOpenCourse () {
      if (this.coursemeta.has_next) {
        await this.$nextTick()
        this.observerCourse.observe(this.$refs.loadCourse)
      }
    },
    onCloseCourse () {
      this.observerCourse.disconnect()
    },
    viewTab (type) {
      if (type === 'grid') {
        this.grid = true
        this.list = false
      } else if (type === 'list') {
        this.grid = false
        this.list = true
      }
    },

    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        vm.fetchCourseList()
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    getCourseTypeName (type) {
      const getType = this.course_class_type_list.filter((ele) => {
        return ele.value.includes(type)
      })
      if (getType.length) return getType[0].name
      return 'Not Available'
    },
    getDSubjects (subjects) {
      const subjects_array = subjects.map((e) => {
        if (e.subject_name) {
          return e.subject_name
        }
      })
      return subjects_array.length > 0
        ? subjects_array.join(', ')
        : 'Not Available'
    },
    async fetchCourseList () {
      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        const payload = {}

        payload.search = this.search
        payload.limit = 10

        if (this.course_name) {
          payload.course_name = this.course_name
        }

        if (this.delivery_location_id) {
          payload.delivery_location_id = this.delivery_location_id
        }
        if (this.course_payment_type) {
          payload.course_payment_type = this.course_payment_type
        }
        if (this.course_type) {
          payload.course_type = [this.course_type.type]
        }
        if (this.teacher_id) {
          payload.teacher_id = [this.teacher_id]
        }
        if (this.course_id) {
          payload.course_id = [this.course_id]
        }
        payload.status = 1
        const customer_id = this.$store.getters.customerId

        const responeList = await newcourseListing(
          //this.course_type,
          customer_id,
          payload,
          this.meta.current_page,
          {},
          'course_table'
        )

        this.courseLists = responeList.data.data.course
        this.meta = responeList.data.data.meta

        this.defaultImage = responeList.data.data.default_course_image
      } catch (error) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    async fetchCourseListForFilter (search) {
      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        const payload = {}
        payload.course_name = search
        payload.status = 1
        const customer_id = this.$store.getters.customerId

        const responeList = await newcourseListing(
          //this.course_type,
          customer_id,
          payload,
          this.meta.current_page,
          {},
          'course_table'
        )

        this.courseListsForfilter = responeList.data.data.course
        this.coursemeta = responeList.data.data.meta

        this.defaultImage = responeList.data.data.default_course_image
      } catch (error) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    getDeliverylocation (delivery_location_id) {
      const delivery_location = this.locations.filter(
        (element) => element.id === delivery_location_id
      )
      return delivery_location[0].name
    }
  }
}
</script>